var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoundary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.07973C2 6.80746 2.10536 6.54635 2.29289 6.35383L4.29289 4.30068C4.68342 3.89977 5.31658 3.89977 5.70711 4.30068L7.70711 6.35383C7.89464 6.54635 8 6.80746 8 7.07973V20H4C2.89543 20 2 19.0808 2 17.9468V7.07973Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 7.07973C22 6.80746 21.8946 6.54635 21.7071 6.35383L19.7071 4.30068C19.3166 3.89977 18.6834 3.89977 18.2929 4.30068L16.2929 6.35383C16.1054 6.54635 16 6.80746 16 7.07973V20H20C21.1046 20 22 19.0808 22 17.9468V7.07973Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29289 6.35383C9.10536 6.54635 9 6.80746 9 7.07973V20H15V7.07973C15 6.80746 14.8946 6.54635 14.7071 6.35383L12.7071 4.30068C12.3166 3.89977 11.6834 3.89977 11.2929 4.30068L9.29289 6.35383Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoundary);
export default __webpack_public_path__ + "static/media/boundary.4c874615dd1dadb822e5606faf29713c.svg";
export { ForwardRef as ReactComponent };